module.exports = __webpack_public_path__ + "static/media/login-info-asset.c2c0e43a.svg";